import App from "./App";
import ManageMember from "./components/ManageMember";
import Home from "./components/Home";
import Main from "./components/Main";
import LoginUser from "./components/Login-User/LoginUser";
import LoginUserSendMail from "./components/Login-User/SendMail";
import LoginUserSendMailSuccess from "./components/Login-User/SendMailSuccess";
import LoginUserVerifySuccess from "./components/Login-User/VerifySuccess";
import DigitalWorkFlow from "./components/Service/DigitalWorkFlow";
import TermAndCondition from "./components/Login-User/TermAndCondition";
import EduPortalManagement from "./components/Service/EduPortalManagement";
import Exchange from "./components/Service/IDConnect";
import DipchipManagement from "./components/Service/DipchipManagement";
import Student from "./components/Service/Pre-register/Student/Student";
import Teacher from "./components/Service/Pre-register/Teacher/Teacher";
import Docter from "./components/Service/Pre-register/Doctor/Docter";
import Officer from "./components/Service/Pre-register/Officer/Officer";
import ApproveUserToBiz from "./components/Service/ApproveUserToBiz";
import ApprovePreRegister from "./components/Service/ApprovePreRegister";
import TimeAttendance from "./components/Service/Pre-register/TimeAttendance/TimeAttendance";
import MophCaregiver from './components/Service/Pre-register/MophCaregiver/MophCaregiver'
import ProviderIDPreRegister from "./components/Service/Pre-register/ProviderIDPreRegister/ProviderIDPreRegister";
import Corporation from "./components/Service/Pre-register/Corporation/Corporation";
import PreRegisterPage from "./components/Service/Pre-register/PreRegisterPage";
import Business from "./components/Service/Business";
import HomeEmail from "./components/Email-Setting/HomeEmail";
import EStamp from "./components/Service/EStamp";
// import RedirectOne from "./components/RedirectOne";

const routes = [
  {
    path: '/:prefix/home',
    index: true,
    component: (
      <>
        <Home />
      </>
    ),
  },
  {
    path: '/:prefix/manage-members',
    index: true,
    component: (
      <>
        <ManageMember />
      </>
    ),
  },
  {
    path: '/:prefix/services/edu-portal-management',
    index: true,
    component: (
      <>
        <EduPortalManagement />
      </>
    ),
  },
  {
    path: '/:prefix/services/id-connect',
    index: true,
    component: (
      <>
        <Exchange />
      </>
    ),
  },
  {
    path: '/:prefix/services/business',
    index: true,
    component: (
      <>
        <Business />
      </>
    ),
  },
  {
    path: '/:prefix/services/e-stamp',
    index: true,
    component: (
      <>
        <EStamp />
      </>
    ),
  },
  {
    path: '/:prefix/services/dipchip-management',
    index: true,
    component: (
      <DipchipManagement />
    ),
  },
  {
    path: '/:prefix/services/digital-workflow',
    index: true,
    component: (
      <>
        <DigitalWorkFlow />
      </>
    ),
  },
  {
    path: '/:prefix/services/digital-workflow/:action',
    index: true,
    component: (
      <>
        <DigitalWorkFlow />
      </>
    ),
  },
  {
    path: '/logout',
    index: true,
    component: (
      <>

      </>
    ),
  },
  {
    path: '/:prefix/login-user',
    index: true,
    component: (
      <>
        <LoginUser />
      </>
    ),
  },
  {
    path: '/:prefix/login-user/send-mail',
    index: true,
    component: (
      <>
        <LoginUserSendMail />
      </>
    ),
  },
  {
    path: '/:prefix/login-user/send-mail/success',
    index: true,
    component: (
      <>
        <LoginUserSendMailSuccess />
      </>
    ),
  },
  {
    path: '/:prefix/login-user/verify-success',
    index: true,
    component: (
      <>
        <LoginUserVerifySuccess />
      </>
    ),
  },
  {
    path: '/login-user/term-and-condition',
    index: true,
    component: (
      <>
        <TermAndCondition />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/student',
    index: true,
    component: (
      <>
        <Student />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/teacher',
    index: true,
    component: (
      <>
        <Teacher />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/doctor',
    index: true,
    component: (
      <>
        <Docter />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/officer',
    index: true,
    component: (
      <>
        <Officer />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/time-attendance',
    index: true,
    component: (
      <>
        <TimeAttendance />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/moph-caregiver',
    index: true,
    component: (
      <>
        <MophCaregiver />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/Corporation',
    index: true,
    component: (
      <>
        <Corporation />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/provider-id',
    index: true,
    component: (
      <>
        <ProviderIDPreRegister />
      </>
    ),
  },
  {
    path: '/:prefix/pre-register/:typeKey',
    index: true,
    component: (
      <>
        <PreRegisterPage />
      </>
    ),
  },
  {
    path: '/:prefix/approve-user',
    index: true,
    component: (
      <>
        <ApproveUserToBiz />
      </>
    ),
  },
  {
    path: '/:prefix/approve-pre-register',
    index: true,
    component: (
      <>
        <ApprovePreRegister />
      </>
    ),
  },
  {
    path: '/:prefix/home-email',
    index: true,
    component: (
      <>
        <HomeEmail />
      </>
    ),
  },
  // {
  //   path: '/redirect-one',
  //   index: true,
  //   component: (
  //     <>
  //       <RedirectOne />
  //     </>
  //   ),
  // },
]

export default routes